/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */
import React from "react";
import PropTypes from "prop-types";
import { useIntl } from "gatsby-plugin-intl";
import { MobileNavProvider } from "context/mobileNavContext";
import MobileMenu from "components/MobileMenu";
import { ServicesModalsProvider } from "components/ServicesModals/";
import Header from "../Header";
import Footer from "../Footer";

import "@fortawesome/fontawesome-svg-core/styles.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./layout.scss";

const Layout = ({ children }) => {
  const { locale } = useIntl();
  const direction = locale === "ar" ? "rtl" : "ltr";

  return (
    <>
      <ServicesModalsProvider>
        <MobileNavProvider>
          <div
            id="layout"
            className="ltr:font-body rtl:font-body-ar"
            dir={direction}
          >
            <Header />
            <MobileMenu />
            {/* 128px is the space between the whole header and the actual page content */}
            <main style={{ marginTop: 105 }} className="">
              {children}
            </main>
            <Footer />
          </div>
        </MobileNavProvider>
      </ServicesModalsProvider>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
